import { render } from "./FoodCreate.vue?vue&type=template&id=f2df7750"
import script from "./FoodCreate.vue?vue&type=script&lang=js"
export * from "./FoodCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__